import sortBy from 'lodash/sortBy';

import {
  getContentItemByUuid
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  LINK_TYPE_INTERNAL
} from 'zoomforth_codesbane_viewer/const/link_types.js';

import { getContentItemType } from './page_content_utils.js';

export const sortGridPositions = (gridPositions) =>
  sortBy(gridPositions, ({ row, col }) => (row * 100) + col);


export const isTilePlayable = (contentItem) => {
  const itemType = getContentItemType(contentItem);
  return (
    itemType === 'video' ||
    itemType === 'youtube'
  );
};

export const doesTileLinkToVideo = (state, contentItem) => {
  if (
    contentItem.tile_action_data && 
    contentItem.tile_action_data.type === LINK_TYPE_INTERNAL && 
    contentItem.tile_action_data.contentUuid
  ) {
    const targetContentItem = getContentItemByUuid(state, contentItem.tile_action_data.contentUuid);
    if (targetContentItem) {
      return isTilePlayable(targetContentItem);
    }
  }
  return false;
};


